import { Platform } from '@angular/cdk/platform';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MonthpickerDateAdapter } from './month-picker-date-adapter.class';
import { MonthPickerHeaderComponent } from './month-picker-header/month-picker-header.component';

@Component({
  selector: 'app-report-date-range-picker',
  templateUrl: './report-date-range-picker.component.html',
  styleUrls: ['./report-date-range-picker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MonthpickerDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform],
    },
  ],
  standalone: false,
})
export class ReportDateRangePickerComponent implements OnInit {
  dateForm!: UntypedFormGroup;
  @Output() rangechanged: EventEmitter<any> = new EventEmitter();
  @Input() isReloading: boolean = true;
  @Input() isInit: boolean = false;

  // Toolbar-height (40px) rendering for dense headers; the default rendering is unchanged
  // for the legacy dashboard consumers.
  @Input() @HostBinding('class.compact') compact = false;

  errorDateRange: boolean = false;

  @Input()
  public monthAndYear: Date | null = null;

  @Output()
  public monthAndYearChange = new EventEmitter<Date | null>();

  headerComponent = MonthPickerHeaderComponent;

  constructor() {}

  ngOnInit(): void {
    this.createDateForm();
  }

  createDateForm() {
    const beginDate = new Date();
    const endDate = new Date();
    beginDate.setMonth(beginDate.getMonth() - 11);

    this.dateForm = new UntypedFormGroup({
      from: new UntypedFormControl(beginDate),
      to: new UntypedFormControl(endDate),
    });

    this.dateForm.valueChanges.subscribe((changes) => {
      if (this.dateForm.value.from > this.dateForm.value.to) {
        this.errorDateRange = true;
        this.rangechanged.emit(undefined);

        return;
      }

      this.errorDateRange = false;

      let range = {
        from: this.dateForm.value.from,
        to: this.dateForm.value.to,
      };

      range.to = this.getNextMonth(range.to);
      this.rangechanged.emit(range);
    });

    this.rangechanged.emit({
      from: beginDate,
      to: endDate,
    });
  }

  getNextMonth(srcto: any): Date {
    let to = new Date(srcto);
    to.setMonth(to.getMonth() + 1);
    return to;
  }

  // Programmatically sets the range (month granularity); goes through the form so the
  // rangechanged emit gets the same normalization as a manual selection.
  public setRange(from: Date, to: Date): void {
    this.dateForm.setValue({ from, to });
  }

  public monthSelectedFrom(value: any, widget: any): void {
    this.dateForm.setValue({ from: value, to: this.dateForm.value.to });
    widget.close();
  }

  public monthSelectedTo(value: any, widget: any): void {
    this.dateForm.setValue({ from: this.dateForm.value.from, to: value });
    widget.close();
  }
}
